import { map } from "./random";

export default class Color{
  constructor(r,g,b) {
    this.r = r;
    this.g = g;
    this.b = b;
  }

  getHex(){
    let code_hex = [
      this.r.toString(16),
      this.g.toString(16),
      this.b.toString(16)
    ]

    let r = "#";
    for (let i = 0; i < code_hex.length; i++) {
      let hex = code_hex[i];
      if(hex.length === 1){
        r += "0";
      }
      r += hex;
    }

    return r;
  }

  getRelativeLuminance(){
    let c = Math.sqrt( 0.299*(this.r**2) + 0.587*(this.g**2) + 0.114*(this.b**2))
    return (c*1)/255;
  }

  getColorToBackground(){
    if(this.getRelativeLuminance() > 0.6){
      return "#000000";
    }
    return "#ffffff"
  }

  getColorEquivalent(n){
    if(n<0){
      let v = map(n*-1,0,1,0,255);
      let r = this.r + v>255?255:this.r + v;
      let g = this.g + v>255?255:this.g + v;
      let b = this.b + v>255?255:this.b + v;
      return new Color(parseInt(r),parseInt(g),parseInt(b));
    } else {
      let v = map(n,0,1,0,255);
      let r = this.r - v<0?0:this.r - v;
      let g = this.g - v<0?0:this.g - v;
      let b = this.b - v<0?0:this.b - v;
      return new Color(parseInt(r),parseInt(g),parseInt(b));
    }
  }
}